import React, { Fragment } from "react";
import { injectIntl } from "react-intl";
import "./Features.scss";
import techImg from "./../../../assets/images/ic_tech-2x.png";
import teamImg from "./../../../assets/images/ic_expert-2x.png";
import networkImg from "./../../../assets/images/ic_network-2x.png";
import easyImg from "./../../../assets/images/ic_easy-2x.png";
import priceImg from "./../../../assets/images/ic_price-2x.png";
import moviesImg from "./../../../assets/images/ic_moves-2x.png";
import databaseImg from "./../../../assets/images/ic_database-2x.png";
import securetyImg from "./../../../assets/images/ic_lock-2x.png";
import onlineImg from "./../../../assets/images/ic_online-2x.png";





import { useSelector } from "react-redux";
import LazyLoad from "react-lazy-load";

function Features({ content, intl }) {
  const lang = useSelector((state) => state.locale.lang);
  const { messages } = intl;
  const renderFeatures = (features) => {
    return (
      features &&
      Array.isArray(features) &&
      features.map((feature, index) => {
        return (
          <>
          <>
            {index === 0 && <h4 className="bold_font mt-4">{feature}</h4>}
            {index === 1 && <p>{feature}</p>}
            {index === 2 && <h4 className="bold_font mt-4">{feature}</h4>}
            {index === 3 && <p>{feature}</p>}
          </>
          </>
        );
      })
    );
  };

  return (
  
    <div className="features__section">
      <div className="container">
        <div className="features__title text-center mx-auto" data-aos="fade-up" data-aos-duration="2000">
          <h2 className="bold_font mb-5 mb-md-2">{messages.features_content.title1}</h2>
          <h2 className="features__title-minor text-uppercase bold_font">{messages.features_content.title2}</h2>
        </div>
        <div className="feature__content  row justify-content-center mt-0 mt-md-5" data-aos="fade-up"  data-aos-delay="500" data-aos-offset="300" data-aos-duration="2000">
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
              <div className="feature-content-img">
              <img src={techImg} alt="techImg" className=" d-block m-auto" />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_2_title}</p>
            </div>
          </div>
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="feature-content-img">
              <img src={teamImg} alt="teamImg"  className=" d-block mx-auto " />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_1_title}</p>
            </div>
          </div>
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="feature-content-img">
              <img src={networkImg} alt="networkImg" className=" d-block m-auto" />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_5_title}</p>
            </div>
          </div>
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="feature-content-img">
              <img src={easyImg} alt="easyImg"  className=" d-block mx-auto" />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_3_title}</p>
            </div>
          </div>
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4 ">
            <div className="feature-content-img">
              <img src={priceImg} alt="priceImg"  className=" d-block mx-auto" />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_4_title}</p>
            </div>
          </div>{" "}
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="  feature-content-img">
              <img src={moviesImg} alt="moviesImg"  className=" d-block mx-auto " />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_8_title}</p>
            </div>
          </div>{" "}
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="feature-content-img">
              <img src={databaseImg} alt="databaseImg"  className=" d-block mx-auto " />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_9_title}</p>
            </div>
          </div>{" "}
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4 p-2 ">
            <div className="feature-content-img">
              <img src={securetyImg} alt="securetyImg"  className=" d-block mx-auto " />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_7_title}</p>
            </div>
          </div>{" "}
          <div className="col-sm-4 col-6 mt-md-5 mt-2">
       
            <div className="feature__content-item row align-items-center justify-content-center p-3 p-md-4">
            <div className="feature-content-img">
              <img src={onlineImg} alt="onlineImg"  className=" d-block m-auto" />
              </div>
              <p className="semi_bold_font mx-xl-3 text-uppercase ">{messages.features_content.feature_6_title}</p>
            </div>
          </div>
        </div>




      </div>
    </div>
  );
}

const FeaturesComponent = injectIntl(Features);

export default FeaturesComponent;
